// extracted by mini-css-extract-plugin
export var avatarContainer = "_gy-0";
export var avatarTypingWave = "_gy-i";
export var gray = "_gy-f";
export var green = "_gy-c";
export var icon = "_gy-9";
export var image = "_gy-1";
export var lg = "_gy-6";
export var md = "_gy-5";
export var presenceDot = "_gy-b";
export var red = "_gy-d";
export var sm = "_gy-4";
export var status = "_gy-a";
export var typingDot = "_gy-h";
export var typingPill = "_gy-g";
export var xl = "_gy-7";
export var xs = "_gy-3";
export var xxl = "_gy-8";
export var xxs = "_gy-2";
export var yellow = "_gy-e";